import { css } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

import { InnerBottomProps } from "../types";

const InnerBottom = ({ children }: InnerBottomProps) => {
    const { gray200 } = colors;

    return (
        <div
            css={css({
                padding: "24px",
                borderTop: `1px solid ${gray200}`
            })}
        >
            {children}
        </div>
    );
};

export { InnerBottom };
